import { ServiceBase } from 'travco-services';

class DataService extends ServiceBase {

    constructor(token) {
        super();
        this._token = token;
    }

    setToken(token) {
        this._token = token;
    }

    getEnum(type) {
        return super.fetch('/api/static/' + type, 'get', null, this._token);
    }
}

export default DataService;
